import { useQuery } from '@tanstack/react-query';

import { $api } from '../../global';
import { IUnFinishedRes } from '../models';
import { unFinishedTestsConst } from '..';

export const useUnFinishedTests = () => {
  const { data: unFinishedTests, ...args } = useQuery<IUnFinishedRes>({
    queryKey: [unFinishedTestsConst.queryKeys.UNFINISHED_TESTS],
    queryFn: async () => {
      const res = await $api.get('/progress');

      return res.data;
    },
    refetchOnMount: true
  });

  return { unFinishedTests, ...args };
};
